import styled from 'styled-components';

const TruncatedText = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
`;

export default TruncatedText;
